import React from 'react'
import classnames from 'classnames/bind'
import { Link } from "gatsby"

// Lib MISC
import styles from './style.scss'
import words from "@/assets/worddict.json"

const cx = classnames.bind(styles)

export const propTypes = {}

function Footer ({ lang }) {
  const $t = words[lang]

  return (
    <div className={cx('footer')}>
      <div className={cx('footer-wrap')}>
        <div className={cx('footer-wrap-left')}>
          <p className={cx('footer-wrap-left-text')}>{$t.TXT_Footer_context}</p>
        </div>
        <div className={cx('footer-wrap-right')}>
          <Link to={`/${lang}/TermsOfService`} className={cx('footer-wrap-right-text')}>{$t.TXT_Footer_terms_of_service}</Link>
          <Link to={`/${lang}/PrivacyPolicy`} className={cx('footer-wrap-right-text')}>{$t.TXT_Footer_privacy_policy}</Link>
        </div>
      </div>
    </div>
  )
}

Footer.propTypes = propTypes

export default Footer
